import React from 'react';

/**
 * As barras de sinal da marca, com dado de verdade: uma barra por área, a
 * altura é o peso dela na nota e o topo vazio é o que a área perdeu.
 *
 *   areas   ordem das barras (do menor peso ao maior)
 *   pesos   { area: pontos }
 *   perdas  { area: pontos perdidos }
 *   rotulo  (area) => texto do rótulo
 *   decimal (n) => número formatado no idioma
 *   foco    área em destaque, opcional
 */
const Barras = ({ areas, pesos, perdas, rotulo, decimal, foco }) => (
  <>
    <div className="nh-barras">
      {areas.map((area) => (
        <div
          className={area === foco ? 'nh-barra is-foco' : 'nh-barra'}
          key={area}
          style={{ '--peso': pesos[area] }}
        >
          <span className="nh-barra-perda">−{decimal(perdas[area])}</span>
          <div className="nh-barra-col">
            <div
              className="nh-barra-mantida"
              style={{ '--mantida': (pesos[area] - perdas[area]) / pesos[area] }}
            />
          </div>
        </div>
      ))}
    </div>
    <div className="nh-rotulos">
      {areas.map((area) => (
        <span key={area}>
          <b>{rotulo(area)}</b>
          {pesos[area]}
        </span>
      ))}
    </div>
  </>
);

export default Barras;
